<template>
    <q-list no-border>
        <q-list-header class="q-pr-lg text-center q-my-xs">
            <router-link to="/"><img src="../../img/identity/sandflix_logo.png" width="70%"/></router-link>
        </q-list-header>
        <q-item item>
            <div class="row items-baseline">
                <div class="lang" style="margin-left: 0">
                  <div v-if="multilingue">
                    <q-btn no-caps dense flat rounded color="faded" v-ripple
                           icon="fas fa-globe" class="account on-right text-bold"
                           :label="locale.toUpperCase()">
                      <q-popover class="account">
                        <q-list separator class="q-pt-none">
                          <template>
                            <div v-for="(enabled, index) in this.enabledLanguages">
                              <q-item v-close-overlay link class="justify-center" v-if='locale !== index'>
                                <div @click.prevent="setLocale(index)" style="cursor: pointer">{{ $T(enabled) }}</div>
                              </q-item>
                            </div>
                          </template>
                        </q-list>
                      </q-popover>
                    </q-btn>
                  </div>
                </div>
            </div>
        </q-item>

        <q-item v-for="menu in userMenu" :key="menu.name"
                v-ripple link item exact class="big" :to="menu.slug">
            {{ $T(menu.name) }}
        </q-item>

        <q-item-separator/>

        <q-item item>
            <div class="row full-width items-baseline">
                <div class="col">
                    <q-input v-model="query" :placeholder="$T('search')"
                             @keydown.enter.prevent="search"/>
                </div>
                <div class="col-auto">
                    <q-btn icon="search" color="primary" class="super-hover on-right"
                           @click.prevent="search"></q-btn>
                </div>
            </div>
        </q-item>

        <q-item-separator/>
        <!--
        Esses dois primeiros ai embaixo deveriam ser dinâmicos tb. Um "submenu"
        O "minha conta" deve verificar se já está logado v-if.
        Assim como o login/esqueci a senha, logout
        -->
        <q-item link :to="{name: 'contact'}">{{ $T('contact us') }}</q-item>
        <q-item link :to="{name: 'tec'}">{{ $T('terms ans conditions') }}</q-item>
        <q-item v-if="user" link :to="{name: 'favourites'}">{{ $T('favourites') }}</q-item>
        <q-item link to="/profile">{{ $T('my account') }}</q-item>

        <q-item-separator/>
        <q-item>
            <div class="col" v-if="user">
                <h6 class="q-mt-none q-mb-xs">{{ $T('welcome to funzzone!') }}</h6>
                {{ $T('close your session') }}
                <q-btn color="primary" class="full-width super-hover q-my-md"
                       :label="$T('log out')" link @click.native="logout"></q-btn>
            </div>

            <div class="col" v-else>
                <h6 class="q-mt-none q-mb-xs">{{ $T('welcome to funzzone!') }}</h6>
                {{ $T('start your session') }}
                <q-btn color="primary" class="full-width super-hover q-my-md"
                       :label="$T('log in')" @click.prevent="$login()"></q-btn>
            </div>

        </q-item>
        <q-item>
            <div class="col text-center"><small>© Funzzone - V{{ getVersion() }}</small></div>
        </q-item>
    </q-list>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'

    import {
        QList,
        QPopover,
        QListHeader,
        QItem,
        QItemSeparator,
        QBtn,
        QInput
    } from 'quasar-framework'

    export default {
        data: () => ({
            language: window.config.locale,
            lang: '',
            redirect: '',
            logo: `${config.appUrl}${config.devAssetsFolder}/img/p4f.svg`,
            query: '',
            enabledLanguages: window.config.enabled_locales,
            multilingue: window.config.multilingue,
            selected: ''
        }),
        components: {
            QList,
            QPopover,
            QListHeader,
            QItem,
            QItemSeparator,
            QBtn,
            QInput
        },

        computed: {
            ...mapGetters({
                user: 'auth/user',
                locale: 'lang/locale',
                locales: 'lang/locales',
                userMenu: 'userMenu/userMenu'
            }),

            menus() {
                this.redirect = '/'+this.$route.path.split('/').join('*')
                return window.config.menus
            }
        },

        methods: {
            async logout() {
                this.$router.push("/")
                // Log out the user.
                await this.$store.dispatch('auth/logout')

                // Redirect to login.
                window.location.href = '/logout'
            },

            setLocale(locale) {
              this.$q.i18n.rtl=false;
              if (this.$i18n.locale !== locale) {
                loadMessages(locale)

                this.$store.dispatch('lang/setLocale', {locale})
                this.$q.i18n.rtl=false;
                window.location.href = this.$route.path
              }
            },

            search() {
                this.$router.push({ name: 'sports.search', params: {query: this.query} })
            },

            getVersion() {
                return `${config.appVersion}`
            },
        }
    }
</script>

<style scoped>
.lang{
    margin-left: 60%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Menu.vue